/**
 * @voltxampere/ui — Push button (momentary) variant (Sprint 44-3)
 *
 * Normally-open momentary push button — kullanıcı bastığında
 * iletken (closed=true), bıraktığında açık. Mevcut `switch`
 * stamp default closed=false ile NO momentary davranışı doğru
 * temsil eder. UI seviyesinde "press-and-hold" interaction
 * Sprint 47+ canvas event handler ile aktif.
 *
 * Reference: Generic momentary tactile push button (e.g. SPST-NO
 * panel mount, 12 mm cap). 50 mA @ 12 V DC. Reset, start, mode,
 * onay düğmesi.
 *
 * Engine zero-diff invariant honored — canonical `switch` engine
 * type via schemaType (NO momentary = default switch open state).
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { switchSymbol } from "../switch.js";
export const switchPushButton = {
    id: "switch-push-button",
    nameTr: "Push Button (NO Momentary)",
    nameEn: "Push Button (NO Momentary)",
    shortcut: "S",
    category: "passive",
    viewBox: switchSymbol.viewBox,
    terminals: switchSymbol.terminals,
    defaultLabel: "SW",
    defaultValue: "PB-NO",
    schemaType: "switch",
    defaultParams: { closed: false, Ron: 1e-3, Roff: 1e9 },
    renderSVG: () => switchSymbol.renderSVG(),
};
//# sourceMappingURL=switch-push-button.js.map